export function eur(n) {
  const v = Number(n || 0);
  return v.toLocaleString("it-IT", { style: "currency", currency: "EUR", useGrouping: true });
}

export function fmtDate(d) {
  if (!d) return "—";
  const date = new Date(d);
  if (isNaN(date)) return d;
  return date.toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
}

export function fmtDateTime(d) {
  if (!d) return "—";
  const date = new Date(d);
  if (isNaN(date)) return d;
  return date.toLocaleString("it-IT", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fmtTime(d) {
  if (!d) return "";
  const date = new Date(d);
  if (isNaN(date)) return "";
  return date.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
}

export const STATUS_LABELS = {
  nuova: "Da programmare",
  presa_in_carico: "In corso",
  programmata: "Programmato",
  completata: "Completato",
  da_verificare: "Da verificare",
  annullata: "Annullato",
};

const STATUS_STYLES = {
  nuova: "bg-sky-100 text-sky-900 border-sky-200",
  presa_in_carico: "bg-blue-100 text-blue-900 border-blue-200",
  programmata: "bg-amber-100 text-amber-900 border-amber-200",
  completata: "bg-[#e8f0eb] text-[#2f5d3e] border-[#d1e2d5]",
  da_verificare: "bg-red-100 text-red-900 border-red-200",
  annullata: "bg-slate-100 text-slate-500 border-slate-200",
};

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}

const PRO_STATUS_LABELS = {
  nuova: "In attesa di programmazione",
  programmata: "Assegnato",
  presa_in_carico: "In corso",
  completata: "Completato",
};

export function ProStatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}
    >
      {PRO_STATUS_LABELS[status] || STATUS_LABELS[status] || status}
    </span>
  );
}

const PAYMENT_LABELS = {
  completato: "Pagato",
  in_attesa: "In attesa",
  in_verifica: "In verifica",
  annullato: "Annullato",
  preventivo: "Preventivo",
};

const PAYMENT_STYLES = {
  completato: "bg-[#e8f0eb] text-[#2f5d3e] border-[#d1e2d5]",
  in_attesa: "bg-amber-100 text-amber-900 border-amber-200",
  in_verifica: "bg-[#f0f7ff] text-[#1e3a5f] border-[#dbe7f3]",
  annullato: "bg-red-100 text-red-900 border-red-200",
  preventivo: "bg-slate-100 text-slate-600 border-slate-200",
};

export function PaymentBadge({ status, method }) {
  const label =
    status === "in_attesa" && method === "contanti" ? "Da riscuotere"
    : status === "in_attesa" && method === "bonifico" ? "In attesa di bonifico"
    : PAYMENT_LABELS[status] || status;
  return (
    <span
      data-testid={`payment-badge-${status}`}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border whitespace-nowrap ${PAYMENT_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}
    >
      {label}
    </span>
  );
}

export function Loading({ label = "Caricamento in corso…" }) {
  return (
    <div data-testid="loading" className="flex items-center justify-center py-20">
      <div className="flex items-center gap-3 text-muted-soft">
        <span className="h-5 w-5 rounded-full border-2 border-[#4a7c59] border-t-transparent animate-spin" />
        <span className="text-sm">{label}</span>
      </div>
    </div>
  );
}

export function EmptyState({ title, children }) {
  return (
    <div className="card-ivory p-8 text-center" data-testid="empty-state">
      <p className="font-serif text-xl text-navy mb-1">{title}</p>
      {children && <div className="text-sm text-muted-soft">{children}</div>}
    </div>
  );
}

export function Stat({ label, value, hint, testid, onClick }) {
  return (
    <div
      className={`card-soft p-6${onClick ? " cursor-pointer" : ""}`}
      data-testid={testid}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter") onClick(); } : undefined}
    >
      <p className="eyebrow mb-2">{label}</p>
      <p className="font-serif text-4xl text-navy leading-none">{value}</p>
      {hint && <p className="text-xs text-muted-soft mt-2">{hint}</p>}
    </div>
  );
}

export function Field({ label, children, testid }) {
  return (
    <div data-testid={testid}>
      <label className="label-soft">{label}</label>
      {children}
    </div>
  );
}
